import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import AnnouncementBar from "./components/AnnouncementBar";
import Footer from "./components/Footer";
import RegisterEmprunteur from "./pages/register-emprunteur/RegisterEmprunteur";
import "./App.css";
import Home from "./pages/Home/Home";
import HomeEmprunteur from "./pages/home-emprunteur/HomeEmprunteur";
import GenericTemplate from "./pages/generic-template/GenericTemplate";
import ScrollToTop from "./components/ScrollToTop";
import BoostPretup from "./pages/boost-pretup/BoostPretup";
import Faq from "./pages/faq/Faq";
import Preter from "./pages/preter/Preter";
import Tutorials from "./pages/tutorials/Tutorials";
import Tutorial from "./pages/tutorial/Tutorial";
import Loader from "./components/Loader";
import Projects from "./pages/projects/Projects";
import NotFound from "./components/NotFound";
import LoginRedirect from "./components/LoginRedirect";
import Landing from "./pages/landing/Landing";
import HomeBlog from "./pages/home-blog/HomeBlog";
import ArticleBlog from "./pages/article-blog/ArticleBlog";
import ContactPage from "./pages/contact/ContactPage";
import RegisterPage from "./pages/register/RegisterPage";
import MobileApp from "./pages/MobileApp/MobileApp";
import Investir from "./pages/investir/Investir";

const Statistics = React.lazy(() => import("./pages/statistics/Statistics"));

const App = () => {
    return (
        <div className="px-2">
            {/* Conteneur sticky partagé : le bandeau et l'en-tête doivent rester
                visibles ensemble. Sans annonce publiée, il ne contient que le
                <Header /> et reproduit exactement les classes qui lui ont été
                retirées, donc le rendu est identique à l'existant. */}
            <div className="sticky top-0 z-50 mb-12 bg-white">
                <AnnouncementBar />
                <Header />
            </div>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/emprunteur" element={<HomeEmprunteur />} />
                <Route path="/investir" element={<Investir />} />
                <Route path="/inscription/preteur" element={<RegisterPage />} />
                <Route path="/preter/ouvrez-votre-compte-pretup" element={<RegisterPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/lexique" element={<GenericTemplate />} />
                <Route path="/taux-de-rendement-interne" element={<GenericTemplate />} />
                <Route path="/mentions-legales" element={<GenericTemplate />} />
                <Route path="/nous-recrutons" element={<GenericTemplate />} />
                <Route path="/politique-de-confidentialite" element={<GenericTemplate />} />
                <Route path="/a-propos-de" element={<GenericTemplate />} />
                <Route path="/actualites" element={<GenericTemplate />} />
                <Route path="/partenaires" element={<GenericTemplate />} />
                <Route path="/pretup-en-bref" element={<GenericTemplate />} />
                <Route path="/cgu" element={<GenericTemplate />} />
                <Route path="/preter/tutoriels" element={<Tutorials />} />
                <Route path="/preter/tutoriel/1" element={<Tutorial />} />
                <Route path="/preter/tutoriel/2" element={<Tutorial />} />
                <Route path="/preter/tutoriel/3" element={<Tutorial />} />
                <Route path="/preter/tutoriel/4" element={<Tutorial />} />
                <Route path="/preter/tutoriel/5" element={<Tutorial />} />
                <Route path="/preter/tutoriel/6" element={<Tutorial />} />
                <Route path="/projets" element={<Projects />} />
                <Route path="/reclamation" element={<GenericTemplate />} />
                <Route path="/communique-de-presse" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation/selection-des-pme" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation/analyse-financiere" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation/cotation" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation/tarification" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation/organes-de-decision" element={<GenericTemplate />} />
                <Route path="/preter/methodes-de-cotation/suivi-des-financements" element={<GenericTemplate />} />
                <Route path="/garanties" element={<GenericTemplate />} />
                <Route path="/fiscalite" element={<GenericTemplate />} />
                <Route path="/avis-clients" element={<GenericTemplate />} />
                <Route path="/financement-solidaire---associations" element={<GenericTemplate />} />
                <Route path="/preter/faq-preteur" element={<Faq />} />
                <Route path="/emprunter/faq-emprunteur" element={<Faq />} />
                <Route path="/preter/preter-a-des-entreprises" element={<Preter />} />
                <Route path="/pret-automatique-boost-pretup" element={<BoostPretup />} />
                <Route path="/dynamisez-votre-epargne-jusqu-a-11-pourcent" element={<Landing />} />
                <Route path="/appli-mobile" element={<MobileApp />} />
                <Route
                    path="/statistiques"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <Statistics />
                        </React.Suspense>
                    }
                />
                <Route path="/login.php" element={<LoginRedirect />} />
                <Route path="/blog" element={<HomeBlog />} />
                <Route path="/blog/articles/:id" element={<ArticleBlog />} />
                <Route path="/emprunteur/inscription" element={<RegisterEmprunteur />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
        </div>
    );
};

export default App;
